module.exports = __webpack_public_path__ + "static/media/meshiya_c.15857472.jpg";